import { ExtraParameterFieldType } from '../../../../shared/enum/ExtraParameterFieldType';

export interface IExtraParameterFieldType {
    name: string
    value: ExtraParameterFieldType
}

export const ExtraParameterFieldTypes: IExtraParameterFieldType[] = [
    { name: 'Opção de Seleção', value: ExtraParameterFieldType.SELECT_OPTION },
    { name: 'Texto', value: ExtraParameterFieldType.TEXT },
    { name: 'Múltipla Seleção', value: ExtraParameterFieldType.SELECT_MULTIPLE },
];